import React from 'react';
import { Chip, ChipColor } from '../../../../../../../../components/Chip';
import { ListCandidateApplication } from '../../../../../../../../entities/applicant_tracking/ListCandidate';
import { channelTypeLabel } from '../../../../../../../../utils/applicant_tracking/sources';

interface PropTypes {
  application?: ListCandidateApplication;
}

export function Channel(props: PropTypes) {
  if (props.application == null || props.application.source == null)
    return (
      <div className='d-flex justify-content-center'>
        <span>-</span>
      </div>
    );

  return (
    <div className='d-flex align-items-center'>
      <Chip className={'py-1 px-2h fw-semibold'} color={ChipColor.Gray}>
        {channelTypeLabel(props.application?.source?.channelType)}
      </Chip>
    </div>
  );
}
